import { Navigate } from 'react-router-dom';
import Login from '../pages/auth/login';

// routes
const authRoutes = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
];

export default authRoutes;
